import { Select } from "web/components/Form/Controls"

export default function ChartViewSelectors({
  kindFieldData,
  groupFieldData,
  weightFieldData,
  chartSettingValues,
  chartSettingValuesHandler,
}) {
  return (
    <>
      <div className="mb-6 w-full">
        <Select
          id={kindFieldData.id}
          label={kindFieldData.label}
          description="Set chart type field"
          kind={kindFieldData.kind}
          value={{ value: chartSettingValues.kind }}
          isRequired={kindFieldData.required}
          placeholder={chartSettingValues.kind.label}
          options={kindFieldData.lookup_values}
          onChange={(value) =>
            !!value && chartSettingValuesHandler("kind", value)
          }
        />
      </div>
      <div className="flex justify-between gap-2">
        <div className="w-1/2">
          <Select
            id={groupFieldData.id}
            label={groupFieldData.label}
            description="Set group by field"
            kind={groupFieldData.kind}
            value={{ value: chartSettingValues.groupBy }}
            isRequired={groupFieldData.required}
            placeholder={chartSettingValues?.groupBy?.label}
            options={groupFieldData.lookup_values}
            onChange={(value) =>
              !!value && chartSettingValuesHandler("groupBy", value)
            }
          />
        </div>
        <div className="w-1/2">
          <Select
            id={weightFieldData.id}
            label={weightFieldData.label}
            description="Set weight by field"
            kind={weightFieldData.kind}
            value={{ value: chartSettingValues.weightBy }}
            isRequired={weightFieldData.required}
            placeholder={chartSettingValues?.weightBy?.label}
            options={weightFieldData.lookup_values}
            onChange={(value) =>
              !!value && chartSettingValuesHandler("weightBy", value)
            }
          />
        </div>
      </div>
    </>
  )
}
